/**
 * Próbuje parsować integera
 *
 * @export
 * @param {...any[]} values
 * @returns {(number | undefined)}
 */
export function tryParseInt(...values: any[]): number | undefined {
  for (const value of values) {
    const parsedValue = parseInt(value);
    if (!isNaN(parsedValue) && parsedValue.toString() === value.toString().replace(/^(0(?!$))+/, '')) {
      return parsedValue;
    }
  }
  return undefined;
}

/**
 * Zwraca pseudo losową liczbę całkowitą od 0 do 100000
 *
 * @export
 * @returns {number}
 */
export function random(): number {
  return Math.floor(Math.random() * 100000);
}
